module.exports = __webpack_public_path__ + "img/cameron-henry.0b2aa17f.png";